import { isUndefined } from '../../TypeHelpers';
export default function sum(array, selector) {
    if (isUndefined(selector)) {
        return array.reduce((p, c) => p + c, 0);
    }
    else {
        return array.map(selector).reduce((p, c) => p + c, 0);
    }
}
